// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__18iXL","rightAdornment":"Header_rightAdornment__1TVZV"};